export function mapDispatchToActions(
  dispatch: React.Dispatch<any>,
  actionCreators: Record<string, Function>
) {
  const actions = Object.keys(actionCreators).reduce((acc, curr) => {
    acc[curr] = (payload: any) => dispatch(actionCreators[curr](payload));
    return acc;
  }, {} as Record<keyof typeof actionCreators, React.Dispatch<any>>);
  return actions;
}
